import {  NgModule } from '@angular/core';

import { LazyBackgroundDirective } from '../directives/appLazyBackground.directive';
import { NoDblclickDirective } from '../directives/no-dblclick.directive';
import { NgxGooglePlacesDirective } from  '../directives/ngxGooglePlaces.directve';

@NgModule({
    declarations: [NoDblclickDirective,LazyBackgroundDirective,NgxGooglePlacesDirective],
    exports: [NoDblclickDirective,LazyBackgroundDirective,NgxGooglePlacesDirective],
   
})
export class GspDirectivesModule { }

